import React from 'react';

import { features } from '@domain/feature-toggle';
import { IconVtex } from '@paretogroup/tess';
import { Paragraph } from '../integration-strategies/modal-strategy/modal-strategy.styles';

import {
    TEST_ID,
    SLOT_TITLE,
    MODAL_TITLE,
    MODAL_SUBTITLE_INITIAL,
    MODAL_SUBTITLE_FINAL,
    API_TOKEN_LINK,
    INTEGRATION_ID,
    APPCUES_ID,
} from './vtex.constants';
import { Vtex } from './vtex-modal-container';
import { createFeatureToggleModalIntegration } from '../integration-strategies';
import { ICON_SIZE, TEXTS } from '../integrations.constants';

const Subtitle = () => (
    <Paragraph>
        { MODAL_SUBTITLE_INITIAL }
        <a href={API_TOKEN_LINK} target="_BLANK" rel="noopener noreferrer">{ MODAL_SUBTITLE_FINAL }</a>
    </Paragraph>
);

export const vtexIntegration = createFeatureToggleModalIntegration({
    id: INTEGRATION_ID,
    title: SLOT_TITLE,
    icon: <IconVtex
        size={ICON_SIZE}
    />,
    testId: TEST_ID,
    feature: features.reportIntegration,
    modal: {
        title: MODAL_TITLE,
        subtitleComponent: Subtitle,
        body: Vtex,
    },
    dataAppcuesId: APPCUES_ID,
    subtitle: TEXTS.MAINTENANCE,
});
